import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-2 loginForm" }
const _hoisted_2 = { class: "my-1" }

import { inject, ref, computed, Ref } from 'vue'
import { DEFAULT_CONFIG, useConfig, useConfigSync } from '@/config/useConfig'
import { useAsyncState } from '@vueuse/core'
import { Redirect } from '@/types/redirect'


export default /*@__PURE__*/_defineComponent({
  __name: 'NewLoginForm',
  props: ['isSubmitting'],
  emits: ['formSubmitted'],
  setup(__props, { emit: __emit }) {

const redirect = inject('redirect') as Redirect

const showForgotPassword = computed(() => {
  const config = useConfigSync()
  return config?.login_ui_methods?.forgot_password === true || config?.login_ui_methods?.forgot_password === 'true'
})

const onClickForgotPassword = async () => {
  const config = await useConfig()
  redirect('ForgotView')
}

const props = __props
const hideForm: Ref<boolean> = ref(false)
const { state } = useAsyncState(
  useConfig(),
  DEFAULT_CONFIG.value
)
hideForm.value = state.value?.api?.hide_login_form !== undefined ? state.value.api.hide_login_form : false

const emit = __emit

const email: Ref<string> = ref('')
const password: Ref<string> = ref('')

const formSubmitted = () => {
  email.value = email.value.trim()
  emit('formSubmitted', {
    email: email.value,
    password: password.value
  })
}

const disableForm = computed(() => !email.value || !password.value)


return (_ctx: any,_cache: any) => {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_lp_button = _resolveComponent("lp-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(formSubmitted, ["prevent"])
    }, [
      _createVNode(_component_lp_input, {
        modelValue: email.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        placeholder: "Email",
        class: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_lp_input, {
        modelValue: password.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
        placeholder: "Password",
        type: "password",
        compact: ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        (showForgotPassword.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: onClickForgotPassword,
              class: "blue-link"
            }, "Forgot your password?"))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_lp_button, {
        disabled: disableForm.value || props.isSubmitting,
        type: "primary",
        class: "w-100 mt-1 btn-loading-active",
        loading: props.isSubmitting
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Sign In", -1)
        ]))]),
        _: 1
      }, 8, ["disabled", "loading"])
    ], 32)
  ]))
}
}

})